import React from 'react'
import { Badge, Box, useTheme } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import PandaIconSvg from './panda-icon-svg'

interface CreateContractIconProps {
  disabled: boolean
  isCompleted: boolean
  size?: number
}

const CreateContractIcon = ({ disabled, isCompleted, size = 45 }: CreateContractIconProps) => {
  const theme = useTheme()
  return (
    <Badge
      badgeContent={isCompleted ? <DoneIcon fontSize="small" sx={{ color: 'text.success' }} /> : null}
      color="secondary"
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: 'transparent',
        },
      }}
    >
      <Box
        sx={{
          opacity: isCompleted ? 0.5 : disabled ? 0.2 : 1,
        }}
      >
        <PandaIconSvg
          size={size}
          bgColor={isCompleted ? theme.palette.background.defaultdim : theme.palette.icon.pandadoc}
          fgColor={isCompleted ? theme.palette.icon.pandadoc : theme.palette.text.primary}
        />
      </Box>
    </Badge>
  )
}
export default CreateContractIcon
